import { ENG4U } from "../../data/OSSD/Grade12/ENG4U";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";

export default function ENG4UPage() {
    return (
        <div>
            <GradeCourseTemplate data={ENG4U} />
        </div>
    )
}